import { FlowWay, getCashFlowWay } from 'components/common-form/sidePanel/status/cashFlowWayUtils';
import { connect } from 'react-redux';
import { SolveResultFormat } from 'state/quotes/results/result.model';
import {
  getFormQuoteDetails,
  getFormQuoteResult,
  getQuoteCurrency,
  getQuotePriceInCurrency,
  getQuotePriceInPercent,
  getQuotePricerToBookingInvertedFlow,
  getQuoteRemunerationMode,
  getQuoteSolvingMode,
  getSidePanelTradeWayOrDefault,
} from 'state/selectors';
import type { AppState } from 'state/state.model';
import { QuoteWorkspaceType } from 'state/workspaces/model';

export interface OwnProps {
  tabId: string;
  workspaceType: QuoteWorkspaceType;
}
export interface StateProps {
  solvingMode: string;
  isMultipleSolvingMode: boolean;
  solveResult?: number;
  solveResultFormat?: SolveResultFormat;
  priceInPercent?: number;
  priceInCurrency?: number;
  currency?: string;
  flowWay: FlowWay;
}

export type TradePendingState = StateProps & OwnProps;

export const mapStateToProps = (state: AppState, { tabId, workspaceType }: OwnProps): StateProps => {
  const solvingMode = getQuoteSolvingMode(state, tabId);
  const quoteDetails = getFormQuoteDetails(state, workspaceType, tabId);
  const quoteResult = getFormQuoteResult(state, workspaceType, tabId);
  const priceInPercent = getQuotePriceInPercent(state, tabId);
  const priceInCurrency = getQuotePriceInCurrency(state, workspaceType, tabId);
  const currency = getQuoteCurrency(state, workspaceType, tabId);

  const remunerationMode = getQuoteRemunerationMode(state, tabId);
  const tradeWay = getSidePanelTradeWayOrDefault(state, tabId);
  const pricerToBookingInvertedFlow = getQuotePricerToBookingInvertedFlow(state, workspaceType, tabId);
  const cashFlowWay = getCashFlowWay(priceInPercent, remunerationMode, tradeWay, pricerToBookingInvertedFlow);

  const solveResult = quoteResult?.solveResult;
  const solveResultFormat = quoteResult?.solveResultFormat;

  return {
    solvingMode,
    isMultipleSolvingMode: quoteDetails?.IsMultipleSolvingMode ?? false,
    solveResult,
    solveResultFormat,
    priceInPercent,
    priceInCurrency,
    currency,
    flowWay: cashFlowWay,
  };
};

export const connectTradePending = connect(mapStateToProps);
